import { SignUpWrapper } from "../../components";

export default function SignUpPage() {
  return (
    <div className="spacer-md">
      <SignUpWrapper />
    </div>
  );
}
